import type { Dispatch, ReactNode } from 'react';

import type { VirtualAccount } from 'models/virtualAccount';

import { SelectVirtualAccount } from '@molecules/SelectVirtualAccount';

type Props = {
  accounts: VirtualAccount[];
  accountNumber?: string;
  setAccountNumber: Dispatch<string>;
  children: ReactNode;
};

export const CryptoFundingAccountLayout = ({
  accounts,
  accountNumber,
  setAccountNumber,
  children
}: Props) => {
  return (
    <div className="flex h-[600px] w-full flex-col gap-4">
      <div className="flex w-1/2 flex-col pr-2.5">
        <div>
          <label className="text-xs font-semibold text-content-secondary">
            Account
          </label>
        </div>
        <SelectVirtualAccount
          onChangeCallback={setAccountNumber}
          accounts={accounts}
          allowAll={false}
          currentAccountNumber={accountNumber}
          className="h-12 !w-full"
        />
      </div>
      {children}
    </div>
  );
};
